import { styled as o } from "styled-components";
const t = /* @__PURE__ */ o.span.withConfig({
  componentId: "sc-cf4af4b3-0"
})([
  "",
  ""
], ({ theme: n }) => n.components.visuallyHidden);
export {
  t as default
};
